import React, { useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { Search, Eye, ThumbsUp, Play } from 'lucide-react';

const MediaPortfolio = () => {
  const [searchParams] = useSearchParams();
  const template = searchParams.get('template');
  const role = searchParams.get('role');
  const [activeCategory, setActiveCategory] = useState('All');
  const [activeStylist, setActiveStylist] = useState('All');
  const [searchQuery, setSearchQuery] = useState('');

  // Show Hair Salon - Barber version
  if (template === 'Hair Salon' && role === 'Barber') {
    // Category filters
    const categories = [
      'All',
      'Haircut Tutorials',
      'Before & After',
      'Styling Tips',
      'Product Reviews',
      'Color Transformations',
      'Client Stories',
      'Behind The Scenes'
    ];

    // Stylist filters
    const stylists = [
      { id: 'all', name: 'All', avatar: null },
      { id: '1', name: 'Alex Rivera', avatar: 'AR' },
      { id: '2', name: 'Jordan Blake', avatar: 'JB' },
      { id: '3', name: 'Sam Taylor', avatar: 'ST' },
      { id: '4', name: 'Chris Martinez', avatar: 'CM' },
      { id: '5', name: 'Riley Parker', avatar: 'RP' },
      { id: '6', name: 'Morgan Hayes', avatar: 'MH' }
    ];

    // Story/Featured content
    const storyContent = [
      {
        id: 1,
        thumbnail: 'https://images.unsplash.com/photo-1503951914875-452162b0f3f1?w=400&h=300&fit=crop',
        duration: '0:45',
        title: 'Alex Rivera Studio Session',
        stylist: 'Alex Rivera',
        views: '580K',
        likes: '42K'
      },
      {
        id: 2,
        thumbnail: 'https://images.unsplash.com/photo-1621605815971-fbc98d665033?w=400&h=300&fit=crop',
        duration: '0:38',
        title: 'Perfect Fade Technique',
        stylist: 'Jordan Blake',
        views: '425K',
        likes: '35K'
      },
      {
        id: 3,
        thumbnail: 'https://images.unsplash.com/photo-1562322140-8baeececf3df?w=400&h=300&fit=crop',
        duration: '0:52',
        title: 'Balayage Transformation',
        stylist: 'Sam Taylor',
        views: '380K',
        likes: '28K'
      },
      {
        id: 4,
        thumbnail: 'https://images.unsplash.com/photo-1560066984-138dadb4c035?w=400&h=300&fit=crop',
        duration: '0:41',
        title: 'Modern Styling Tips',
        stylist: 'Chris Martinez',
        views: '315K',
        likes: '24K'
      },
      {
        id: 5,
        thumbnail: 'https://images.unsplash.com/photo-1522337360788-8b13dee7a37e?w=400&h=300&fit=crop',
        duration: '0:45',
        title: 'Client Makeover Story',
        stylist: 'Riley Parker',
        views: '285K',
        likes: '21K'
      },
      {
        id: 6,
        thumbnail: 'https://images.unsplash.com/photo-1599351431202-1e0f0137899a?w=400&h=300&fit=crop',
        duration: '0:48',
        title: 'Beard Grooming Guide',
        stylist: 'Morgan Hayes',
        views: '245K',
        likes: '19K'
      }
    ];

    // Full Library content
    const fullLibrary = [
      {
        id: 7,
        thumbnail: 'https://images.unsplash.com/photo-1503951914875-452162b0f3f1?w=400&h=300&fit=crop',
        duration: '3:42',
        title: 'Complete Haircut Tutorial - Textured Crop',
        stylist: 'Alex Rivera',
        views: '1.5M',
        likes: '99K',
        type: 'Haircut Tutorials',
        typeColor: 'bg-purple-600'
      },
      {
        id: 8,
        thumbnail: 'https://images.unsplash.com/photo-1599351431202-1e0f0137899a?w=400&h=300&fit=crop',
        duration: '12:15',
        title: 'Interview: Building a Successful Salon',
        stylist: 'Jordan Blake',
        views: '842K',
        likes: '56K',
        type: 'Client Stories',
        typeColor: 'bg-pink-600'
      },
      {
        id: 9,
        thumbnail: 'https://images.unsplash.com/photo-1560066984-138dadb4c035?w=400&h=300&fit=crop',
        duration: '45:30',
        title: 'Full Day in the Salon - Behind The Scenes',
        stylist: 'Sam Taylor',
        views: '2.1M',
        likes: '145K',
        type: 'Behind The Scenes',
        typeColor: 'bg-blue-600'
      },
      {
        id: 10,
        thumbnail: 'https://images.unsplash.com/photo-1562322140-8baeececf3df?w=400&h=300&fit=crop',
        duration: '5:28',
        title: 'Color Correction Masterclass',
        stylist: 'Chris Martinez',
        views: '1.2M',
        likes: '87K',
        type: 'Color Transformations',
        typeColor: 'bg-orange-600'
      },
      {
        id: 11,
        thumbnail: 'https://images.unsplash.com/photo-1522337360788-8b13dee7a37e?w=400&h=300&fit=crop',
        duration: '8:45',
        title: 'Product Review: Best Styling Products 2026',
        stylist: 'Riley Parker',
        views: '756K',
        likes: '62K',
        type: 'Product Reviews',
        typeColor: 'bg-green-600'
      },
      {
        id: 12,
        thumbnail: 'https://images.unsplash.com/photo-1621605815971-fbc98d665033?w=400&h=300&fit=crop',
        duration: '4:18',
        title: 'Amazing Beard Transformation',
        stylist: 'Morgan Hayes',
        views: '923K',
        likes: '71K',
        type: 'Before & After',
        typeColor: 'bg-teal-600'
      },
      {
        id: 13,
        thumbnail: 'https://images.unsplash.com/photo-1503951914875-452162b0f3f1?w=400&h=300&fit=crop',
        duration: '6:33',
        title: 'How to Style Short Hair - Quick Tips',
        stylist: 'Alex Rivera',
        views: '1.8M',
        likes: '112K',
        type: 'Styling Tips',
        typeColor: 'bg-yellow-600'
      },
      {
        id: 14,
        thumbnail: 'https://images.unsplash.com/photo-1562322140-8baeececf3df?w=400&h=300&fit=crop',
        duration: '9:22',
        title: 'Blonde to Brunette - Full Process',
        stylist: 'Sam Taylor',
        views: '1.4M',
        likes: '95K',
        type: 'Color Transformations',
        typeColor: 'bg-orange-600'
      }
    ];

    return (
      <div className="min-h-screen bg-black text-white p-6 overflow-y-auto">
        {/* Search Bar */}
        <div className="mb-6">
          <div className="relative">
            <Search className="absolute left-4 top-1/2 transform -translate-y-1/2 text-gray-400 w-5 h-5" />
            <input
              type="text"
              placeholder="Search videos, artists, or content..."
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              className="w-full bg-black border border-gray-400 text-white pl-12 pr-4 py-3 rounded-xl focus:outline-none focus:border-gray-300 hover:border-gray-300 hover:shadow-[0_0_20px_rgba(156,163,175,0.5)] transition-all duration-300"
            />
          </div>
        </div>

        {/* Category Filters */}
        <div className="mb-6 flex gap-3 overflow-x-auto pb-2">
          {categories.map((category) => (
            <button
              key={category}
              onClick={() => setActiveCategory(category)}
              className={`px-4 py-2 rounded-lg font-semibold whitespace-nowrap transition-all ${
                activeCategory === category
                  ? 'bg-purple-600 text-white'
                  : 'bg-black border border-gray-400 text-gray-300 hover:border-gray-300 hover:shadow-[0_0_15px_rgba(156,163,175,0.3)]'
              }`}
            >
              {category}
            </button>
          ))}
        </div>

        {/* Stylist Filters */}
        <div className="mb-8 flex gap-4 overflow-x-auto pb-2">
          {stylists.map((stylist) => (
            <button
              key={stylist.id}
              onClick={() => setActiveStylist(stylist.name)}
              className={`flex flex-col items-center gap-2 transition-all ${
                activeStylist === stylist.name ? 'opacity-100' : 'opacity-60 hover:opacity-100'
              }`}
            >
              {stylist.avatar ? (
                <div className={`w-16 h-16 rounded-full flex items-center justify-center font-bold text-sm border-2 transition-all ${
                  activeStylist === stylist.name
                    ? 'bg-gradient-to-br from-purple-600 to-blue-600 border-purple-400'
                    : 'bg-gray-800 border-gray-600'
                }`}>
                  {stylist.avatar}
                </div>
              ) : (
                <div className={`px-4 py-2 rounded-full font-semibold text-sm transition-all ${
                  activeStylist === stylist.name
                    ? 'bg-purple-600 text-white'
                    : 'bg-gray-800 text-gray-300'
                }`}>
                  All
                </div>
              )}
              <span className="text-sm text-gray-400">{stylist.name}</span>
            </button>
          ))}
        </div>

        {/* Story Section */}
        <div className="mb-8">
          <h2 className="text-2xl font-bold mb-4">Story</h2>
          <div className="flex gap-4 overflow-x-auto pb-4">
            {storyContent.map((video) => (
              <div
                key={video.id}
                className="flex-shrink-0 w-80 bg-black border border-gray-400 rounded-xl overflow-hidden hover:border-gray-300 hover:shadow-[0_0_20px_rgba(156,163,175,0.5)] transition-all duration-300 cursor-pointer"
              >
                <div className="relative">
                  <img
                    src={video.thumbnail}
                    alt={video.title}
                    className="w-full h-48 object-cover"
                  />
                  <div className="absolute bottom-2 right-2 bg-black/80 px-2 py-1 rounded text-xs font-semibold">
                    {video.duration}
                  </div>
                  <div className="absolute inset-0 flex items-center justify-center opacity-0 hover:opacity-100 transition-opacity bg-black/40">
                    <div className="w-12 h-12 bg-white/90 rounded-full flex items-center justify-center">
                      <Play className="w-6 h-6 text-black ml-1" />
                    </div>
                  </div>
                </div>
                <div className="p-4">
                  <h3 className="font-semibold mb-1 line-clamp-2">{video.title}</h3>
                  <p className="text-sm text-gray-400 mb-3">{video.stylist}</p>
                  <div className="flex items-center gap-4 text-sm text-gray-400">
                    <div className="flex items-center gap-1">
                      <Eye className="w-4 h-4" />
                      <span>{video.views}</span>
                    </div>
                    <div className="flex items-center gap-1">
                      <ThumbsUp className="w-4 h-4" />
                      <span>{video.likes}</span>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Full Library Section */}
        <div>
          <h2 className="text-2xl font-bold mb-4">Full Library</h2>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4">
            {fullLibrary.map((video) => (
              <div
                key={video.id}
                className="bg-black border border-gray-400 rounded-xl overflow-hidden hover:border-gray-300 hover:shadow-[0_0_20px_rgba(156,163,175,0.5)] transition-all duration-300 cursor-pointer"
              >
                <div className="relative">
                  <img
                    src={video.thumbnail}
                    alt={video.title}
                    className="w-full h-48 object-cover"
                  />
                  <div className={`absolute top-2 left-2 ${video.typeColor} px-2 py-1 rounded text-xs font-semibold`}>
                    {video.type}
                  </div>
                  <div className="absolute bottom-2 right-2 bg-black/80 px-2 py-1 rounded text-xs font-semibold">
                    {video.duration}
                  </div>
                  <div className="absolute inset-0 flex items-center justify-center opacity-0 hover:opacity-100 transition-opacity bg-black/40">
                    <div className="w-12 h-12 bg-white/90 rounded-full flex items-center justify-center">
                      <Play className="w-6 h-6 text-black ml-1" />
                    </div>
                  </div>
                </div>
                <div className="p-4">
                  <h3 className="font-semibold mb-1 line-clamp-2">{video.title}</h3>
                  <p className="text-sm text-gray-400 mb-3">{video.stylist}</p>
                  <div className="flex items-center gap-4 text-sm text-gray-400">
                    <div className="flex items-center gap-1">
                      <Eye className="w-4 h-4" />
                      <span>{video.views}</span>
                    </div>
                    <div className="flex items-center gap-1">
                      <ThumbsUp className="w-4 h-4" />
                      <span>{video.likes}</span>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    );
  }

  // Default view for other templates
  return (
    <div className="min-h-screen bg-black text-white p-8">
      <div className="mb-6">
        <h1 className="text-4xl font-bold mb-2">Media Portfolio</h1>
        <p className="text-gray-400">Video content and media library</p>
      </div>
      
      <div className="bg-transparent border-2 border-white/60 rounded-lg p-8 text-center">
        <p className="text-gray-400 text-lg">This feature is under development.</p>
      </div>
    </div>
  );
};

export default MediaPortfolio;
